import React from "react";
import { useLocation } from "react-router-dom";
import ResidenceCard from "./ResidenceCard";

export default function RelatedResidence(props) {
	const location = useLocation();
	const { residence } = props;
	const to = `/${location?.pathname?.split("/")[1]}/${residence?.slug}`;
	return (
		<div className="mb-5">
			<ResidenceCard residence={residence} to={to} hardNavigate />
		</div>
	);
}
